export var Web3MasterWalletTypes;
(function (Web3MasterWalletTypes) {
    Web3MasterWalletTypes["PROXY_FACTORY_OWNER"] = "PROXY_FACTORY_OWNER";
    Web3MasterWalletTypes["RELAYER"] = "RELAYER";
    Web3MasterWalletTypes["TOKEN_OWNER"] = "TOKEN_OWNER";
})(Web3MasterWalletTypes || (Web3MasterWalletTypes = {}));
//# sourceMappingURL=web3-master-wallet-type.enum.js.map